export default function (sample) {
  // 回帰直線の傾きと切片を求める
  var sx = 0;
  var sy = 0;
  var sxy = 0;
  var sxsq = 0;
  var xmean;
  var ymean;
  var alpha;
  var beta;
  var n;

  sample.forEach(function(val) {
    sx += val.x;
    sy += val.y;
    sxy += val.x * val.y;
    sxsq += Math.pow(val.x,2);
  });

  n = sample.length;
  xmean = sx/n;
  ymean = sy/n;
  beta  = ((n*sxy) - (sx*sy))/((n*sxsq)-(Math.pow(sx,2))); // 傾き
  alpha = ymean - (beta * xmean); // 切片
  
  // 回帰式より、回帰直線描画用データを作成
  var regressionLinePlot = [];
  sample.forEach(function(val) {
    regressionLinePlot.push({'x': val.x, 'y': alpha + beta*val.x});
  });


  // 散布図と回帰直線を描画
  /*window.onload = function() {
    var ctx = document.getElementById("canvas").getContext("2d");
    window.myChart = new Chart(ctx, {
      type: 'scatter',
      data: plotData,
    });
  };*/
function getFixed(num){
  function getDecimalLength(n){
    var x = String(n).split(".")[1];
    return Number(x)?x.length:0;
  }
  for(let d=3;d<9;d++){
    if(getDecimalLength(num.toFixed(d)) >= 3)return d
  }
}
const abdec = Math.max(getFixed(alpha), getFixed(beta))
  // 描画データ
  var plotData = {// 回帰直線
    type: 'scatter',
    label: '回帰直線 y=' + alpha.toFixed(abdec) + '+' + beta.toFixed(abdec) + 'x',
    data: regressionLinePlot,              // 始点と終点のデータ（座標）
    borderWidth : 3,                       // 線幅
    pointRadius: 0.0,                      // 点の形状の半径（0にすると点を描画しない）
    tension: 0,                            // 線を直線にする
    showLine: true,                        // 線を描画
    fill: false,                            // 線とＸ軸で囲まれた範囲の描画

    backgroundColor: "rgba(179,181,198,0.8)",
            
    borderColor: "rgba(179,181,198,1)",//枠線の色
    pointBorderColor: "rgba(179,181,198,1)",//結合点の枠線の色
    pointBackgroundColor: "#fff",//結合点の背景色
    pointRadius: 0,//結合点のサイズ
    pointHoverRadius: 0,//結合点のサイズ（ホバーしたとき）
    pointHoverBackgroundColor: "rgba(179,181,198,1)",//結合点の背景色（ホバーしたとき）
    pointHoverBorderColor: "rgba(220,220,220,1)",//結合点の枠線の色（ホバーしたとき）
    pointHitRadius: 0,//結合点より外でマウスホバーを認識する範囲（ピクセル単位）
  };

  return {data: plotData}
}


// WEBPACK FOOTER //
// ./src/components/correl.js